export function filterObjectValues<T extends object, Key extends keyof T>(
  obj: T,
  filterFunction: (value: T[Key]) => boolean,
) {
  const array = Object.entries(obj)
  const filtered = array.filter(([_, value]) => filterFunction(value))

  return Object.fromEntries(filtered) as Partial<T>
}
